import type { TimesheetEntry } from '@/types/timesheet';

// The backend serialises TimesheetEntry.ProjectId / CostCentreId as numeric
// `long` values, but the frontend TimesheetEntry type (and every id-based
// lookup, e.g. projects.find(p => p.id === entry.projectId)) treats them as
// strings. Without this normalisation, entries loaded from the API carry
// numeric ids that never strict-equal the string project ids, which silently
// breaks features such as Smart Auto-Fill suggestions and the approval
// dialog's edit-mode selectors.
export function parseEntryIds(entry: TimesheetEntry): TimesheetEntry {
  return {
    ...entry,
    projectId: entry.projectId != null ? String(entry.projectId) : entry.projectId,
    costCentreId: entry.costCentreId != null ? String(entry.costCentreId) : entry.costCentreId,
  };
}
